export default {"src":"/_next/static/media/tick.724e1133.svg","height":9,"width":12,"blurWidth":0,"blurHeight":0};